import React, { Component } from 'react';
import { Container, Card, CardText } from 'reactstrap';

class Vacio extends Component {
  static displayName = Vacio.name;

  constructor(props) {
    super(props);        
    this.state = {
        editable: this.props.editable ?? true
    };
  }

  render () {
    return (
      <Container fluid>
        <Card body className="text-center py-3">                
          {this.state.editable
            ? <>
              <CardText>No tienes actividades registradas, pero puedes ingresar una nueva actividad dando click en el botón azul (+).</CardText>
                        <CardText>Si estás interesado en realizar este tipo de actividad escríbenos a <a href='mailto:acompanamiento@espol.edu.ec'>acompanamiento@espol.edu.ec</a></CardText>
              </>
            : <>
              <CardText>No tienes actividades registradas para este tipo de actividad</CardText>
                        <CardText>En caso de tener evidencia de haber participado en este tipo de actividad por favor contáctate a <a href='mailto:acompanamiento@espol.edu.ec'>acompanamiento@espol.edu.ec</a>.</CardText>
              </>
          }
        </Card>
      </Container>
    );
  }
}

export default Vacio;
